import { useCallback, useRef } from "react";
import { useUnmount } from "react-use";
import { useGlobalPrivateChannelListener } from "./useGlobalPrivateChannelListener";

export const useRefetchOnRealtimeFailed = (refetchFunction, realtimeEvent, timeout = 5000) => {
  const interval = useRef();

  const listener = useCallback(() => {
    clearTimeout(interval.current);
  }, []);

  useGlobalPrivateChannelListener(realtimeEvent, listener);

  const watch = useCallback(
    (args) => {
      if (interval.current) {
        clearTimeout(interval.current);
      }
      interval.current = setTimeout(() => {
        refetchFunction(args);
      }, timeout);
    },
    [refetchFunction, timeout]
  );

  useUnmount(() => {
    return () => {
      clearTimeout(interval.current);
    };
  });

  return watch;
};
